'use client' // Error boundaries must be Client Components

import { useEffect } from 'react'

export default function Error({ error, reset }: { error: Error & { digest?: string }, reset: () => void }) {

    useEffect(() => {
        // Log the error to an error reporting service
        console.error(error)
    }, [error])

    function copyToClipboard() {
        navigator.clipboard.writeText(error.stack ?? "")
    }

    return (
        <div>
            <h2>어플리케이션 오류: 클라이언트 측 예외가 발생했습니다.</h2>
            <button onClick={() => reset()}>
                새로고침
            </button>
            <button onClick={() => copyToClipboard()}>
                오류메세지 복사하기
            </button>

            <div>
                <pre>
                    {error.stack}
                </pre>

            </div>
        </div>
    )
}